import { serviceName } from '../resources/serviceConstants';
import {
  OTHER_EFFORTS,
  OTHER_EFFORTS_SAVE,
  OTHER_EFFORTS_EDIT,
} from '../resources/endPoint';

export const otherEffortList = (id) => {
  return {
    url: OTHER_EFFORTS + '?dealId=' + id,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const saveotherEffort = (data) => {
  return {
    url: OTHER_EFFORTS_SAVE,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const editotherEffort = (data) => {
  return {
    url: OTHER_EFFORTS_EDIT,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const deleteotherEffort = (id) => {
  return {
    url: `/v1/deal_other_efforts?id=${id}`,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};
